import {settingsRoutes} from '@dms/routes';

import {composePath} from 'shared/web';

export const getDocumentTemplateEditorPath = (templateId: string) =>
  composePath(settingsRoutes.documentTemplateEditor, {params: {id: templateId}});
